// ============== HELPER FUNCTIONS ===================== ]
function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function getCookie(cname) {
  const name = `${cname}=`;
  const ca = document.cookie.split(';');

  let cvalue;

  ca.forEach(c => {
    let cc = c;

    while (cc.charAt(0) === ' ') {
      cc = cc.substring(1);
    }

    if (cc.indexOf(name) !== -1) {
      cvalue = c.substring(name.length + 1);
    }
  });

  return cvalue;
};


// ============== VALIDATION + setting cookie ===================== ]
const referral_hash = getParameterByName('referral_link');

if(referral_hash && !getCookie('_r_id')) {  
  //   need to set expiration time too
  const validate_url = 'http://dev-staging.herokuapp.com/api/v1/rewards/referral/?md5=' + referral_hash;
  $.get(validate_url, (response) => {
    if(response) {
      const date = new Date();
      date.setTime(date.getTime()+(3*24*60*60*1000)) // 3 days

      const prefix = '_r_id';
      const email = response.customer_email;
      const expires = `expires=${date.toGMTString()}`;
      document.cookie = `${prefix}=${referral_hash}%${email}; ${expires}; path=/`;
    }
  });
}